import React, { useState, useEffect } from "react";
import {
  Dialog, DialogTitle, DialogContent, DialogActions,
  TextField, Button
} from "@mui/material";
import RangeDialog from './addRangeDialog';
import { useOrganization } from "../../../configurations/OrganizationContext";
import useDynamicFontFormatter from "../../../shared/helper/useDynamicFontFormatter";

export default function LabTestDialog({ open, onClose, onSave, editData }) {
  const org=useOrganization();
  const formatText = useDynamicFontFormatter(org?.fontStyle);
  const [testData, setTestData] = useState({ testname: '', unit: '', value: '', testRanges: [] });
  const [rangeDialogOpen, setRangeDialogOpen] = useState(false);
  const [errors, setErrors] = useState({});

  const [editRangeIndex, setEditRangeIndex] = useState(null);
  const [editRangeData, setEditRangeData] = useState(null);

  useEffect(() => {
    if (editData) {
      setTestData(editData);
    } else {
      setTestData({ testname: '', unit: '', value: '', testRanges: [] });
    }
  }, [editData]);


  const validate = () => {
    let tempErrors = {};
    if (!testData.testname) tempErrors.testname = "Test Name is required";
    setErrors(tempErrors);
    return Object.keys(tempErrors).length === 0;
  };

  // Modified add or update logic
  const handleAddRange = (range) => {
    const updatedRanges = [...testData.testRanges];
    if (editRangeIndex !== null) {
      updatedRanges[editRangeIndex] = range; // replace existing
    } else {
      updatedRanges.push(range); // add new
    }
    setTestData((prev) => ({ ...prev, testRanges: updatedRanges }));
    setEditRangeIndex(null);
    setEditRangeData(null);
    setRangeDialogOpen(false);
  };

  // Call this to start editing
  const handleEditRange = (index) => {
    setEditRangeData(testData.testRanges[index]);
    setEditRangeIndex(index);
    setRangeDialogOpen(true);
  };


  const handleSave = () => {
    if (validate()) {
      onSave(testData);
    }
  };

  return (
    <Dialog open={open} onClose={onClose} maxWidth="sm" fullWidth>
      <DialogTitle>{editData ? 'Edit Test' : 'Add Test'}</DialogTitle>
      <DialogContent>
        <TextField
          label="Test Name"
          fullWidth
          value={testData.testname}
          onChange={(e) => setTestData({ ...testData, testname: formatText(e.target.value) })}
          margin="normal"
          error={!!errors.testname}
          helperText={errors.testname}
        />
        <TextField
          label="Unit"
          fullWidth
          value={testData.unit}
          onChange={(e) => setTestData({ ...testData, unit: e.target.value })}
          margin="normal"
        />

        <TextField
          label="Values"
          fullWidth
          value={testData.value}
          onChange={(e) => setTestData({ ...testData, value: e.target.value })}
          margin="normal"
          helperText="For tests with predefined choices (e.g., Yes/No, Positive/Negative), list the options separated by commas (e.g., Yes,No)."
        />

        <Button variant="outlined" onClick={() => setRangeDialogOpen(true)}>
          Add Range
        </Button>
        <ul>
          {testData.testRanges.map((r, i) => (
            <li key={i}>
              Ref: {r.reference}, Gender: {r.gender}, Limit: {r.limit}
              <Button size="small" onClick={() => handleEditRange(i)}>Edit</Button>
            </li>
          ))}
        </ul>

      </DialogContent>
      <DialogActions>
        <Button onClick={onClose}>Cancel</Button>
        <Button variant="contained" onClick={handleSave}>Save</Button>
      </DialogActions>
      {rangeDialogOpen &&
        <RangeDialog
          open={rangeDialogOpen}
          onClose={() => {
            setRangeDialogOpen(false);
            setEditRangeData(null);
            setEditRangeIndex(null);
          }}
          onSave={handleAddRange}
          editData={editRangeData}
        />
      }
    </Dialog>
  );
}
